<div class="row  d-flex justify-content-center"  style="margin-top: 10px;">
        <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <EIPAutoComplete TextField="old_Ref_Id" ValueField="requestNo" WaterMarkText="Review No"
                formControlName="ctrlProject" setId="ddlProject" ShowTextValueField='N' [dataSource]='peerReviewList'
                [defaultValue]="" [SingleValueBind]="false" [IsCascading]='true' (valueChange)='selectedReviewNo($event)'>
            </EIPAutoComplete>
        </div>
    </div>
<div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters"
            [parameters]="parameters" [language]="language" [width]="width" [height]="height" [toolbar]="toolbar">
        </ssrs-reportviewer>
    </div>
</div>
